<template>
  <div class="operationDutyManagementSearch">
    <Row :gutter="4">
      <Col span="4">
        <Input search v-model="name" :placeholder="$t('MCM.dutyManagement.name')" @on-search="searchName()"/>
      </Col>
      <Col span="4">
        <Select v-model="ondutyType" filterable :placeholder="$t('MCM.dutyManagement.dutyType')" :transfer="true"
                @on-change="searchOndutyType()">
          <Option :value="item.id" v-for="item in ondutyTypeList" :key="item.id">{{item.name}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <DatePicker type="month" :placeholder="$t('MCM.dutyManagement.dutyTime')" v-model="startDate" @on-change="searchStartDate()" style="width:100%;"></DatePicker>
      </Col>
      <Col span="6">
        <add-operation-duty-management></add-operation-duty-management>
      </Col>
    </Row>
  </div>
</template>
<script>
  import AddOperationDutyManagement from '../operation_duty_management/AddOperationDutyManagement'
  import TableOperationDutyManagement from '../operation_duty_management/TableOperationDutyManagement'

  var tableOperationDutyManagement = TableOperationDutyManagement;
  export default {
    name: 'OperationDutyManagementSearch',
    components: {
      AddOperationDutyManagement
    },
    data() {
      return {
        name: '',
        ondutyType: '',
        startDate: '',
        ondutyTypeList: [{
          id: 0,
          name: this.$t('MCM.dutyManagement.dayShift')
        }, {
          id: 1,
          name: this.$t('MCM.dutyManagement.nightShift')
        }]
      }
    },
    methods: {
      // 按姓名筛选
      searchName: function () {
        eventBus.$emit('name', this.name);
        tableOperationDutyManagement.methods.showAll();
      },
      // 按值班类型筛选
      searchOndutyType: function () {
        eventBus.$emit('ondutyType', this.ondutyType);
        tableOperationDutyManagement.methods.showAll();
      },
      // 按值班年月筛选
      searchStartDate: function () {
        eventBus.$emit('startDate', this.startDate);
        tableOperationDutyManagement.methods.showAll();
      }
    }
  }
</script>
<style scoped>
  .operationDutyManagementSearch {
    padding: 4px 0px 15px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/operation_kpi_configuration_management/operation_duty_management/OperationDutyManagementSearch.vue